<template>
    <div>
        <div class="row">
            <div class="col">
                <h5>Abstract Options:</h5>
                <div>Please select the option which is best suited to your submission.<br>
                    Click <a href="https://www.aids2022.org/take-part/abstract-submission/" target="_blank">here</a> to view the abstract guidelines
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div class="alert alert-info mb-1">
                    <div class="row">
                        <div class="col-1 d-flex">
                            <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
                        </div>
                        <div class="col">
                            Please note that you <span class="text-danger">may not change the option later</span> in the
                            abstract submission process.<br>
                            If you would like to use a different option, you will have to create a new
                            abstract.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-sm-6">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-success">Option 1</h5>
                        <p class="card-text">
                            Suited for <span class="text-success">research</span> conducted in all disciplines. Check a sample
                            abstract
                            for this option <a href="http://programme.aids2018.org/Abstract/Abstract/7654"
                                               target="_blank">here</a>.<br>
                            Abstracts submitted under the first option should contain concise statements of:<br>
                        <ul>
                            <li class="mt-2"><b>Background:</b> Indicate the purpose and objective of the research, the hypothesis that was tested, or a description of the problem being analysed or evaluated.
                            </li>
                            <li><b>Methods:</b> Describe the study period, setting and location, study design, study population, data collection and methods of analysis used.
                            </li>
                            <li><b>Results:</b> Present as clearly and in as much detail as possible the findings and/or outcomes of the study. Please disaggregate data by age and gender where possible and summarize any specific results.
                            </li>
                            <li><b>Conclusions:</b> Explain the significance of your study’s findings and/or outcomes for HIV prevention, treatment, care and/or support and future implications of the results.
                            </li>
                        </ul>
                        </p>

                    </div>
                    <div class="card-footer bg-transparent border-0 d-flex">
                        <button class="btn btn-success mx-auto" v-on:click="newAbstract(1)">Select</button>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-success">Option 2</h5>
                        <p class="card-text"> Suited for <span class="text-success">lessons</span> learned through programme,
                            project or policy
                            implementation or management. Check a sample abstract for this option <a
                                    href="http://programme.aids2018.org/Abstract/Abstract/6963" target="_blank">here</a>.<br>
                            Abstracts submitted under the second option should contain concise statements of:
                        <ul>
                            <li class="mt-2"><b>Background:</b> Summarize the purpose, scope and objectives of the programme, project or policy.
                            </li>
                            <li><b>Description:</b> Describe the programme, project or policy period, setting and location, the structure, key population (if applicable) and activities and interventions undertaken in support of the programme, project or policy.
                            </li>
                            <li><b>Lessons learned:</b> Present as clearly and in as much detail as possible the findings and/or outcomes of the programme, project or policy. Include an analysis or evaluation of lessons learned and best practices. Please summarize any specific results that support your lessons learned and best practices.
                            </li>
                            <li><b>Conclusions/next steps:</b> Explain the significance of the findings and/or outcomes of the programme, project or policy for HIV prevention, treatment, care and/or support and future implications of the results.
                            </li>
                        </ul>
                        </p>
                    </div>
                    <div class="card-footer bg-transparent border-0 d-flex">
                        <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">Select</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        name: "AbstractType",
        data() {
            return {
                submitted: false,
            };
        },
        methods: {
            ...mapActions([
                'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
            ]),
            newAbstract(type) {
                if(this.submitted === true) {
                    return false;
                }
                this.submitted = true;
                //IAS SPECIAL Abstracts auf die entsprechende Type Seite leiten
                let template = {
                    "user_id": this.user.id,
                    "type_id": type,
                    "setting_submission_id": 1,
                    "reference_number": this.getSettings(1).reference_number,
                    "content": {},
                    "status_id": 1
                };
                this.CREATE_ABSTRACT(template).then((response) => {
                    let reference_id = ("00000" + response.data.id).slice(-5);
                    this.UPDATE_REFERENCE({
                        "abstract_id": response.data.id,
                        "reference_number": response.data.reference_number + reference_id
                    }).then((responseReference) => {
                        this.$noty.success('Save was successful');
                        this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(1).id)
                    }).catch((error) => {
                        this.$noty.error('Save was <strong>not</strong> successful');
                    });
                }).catch((error) => {
                    this.$noty.error('Save was <strong>not</strong> successful');
                });
            }
        },
        computed: {
            ...mapState([
                'wording', 'user'
            ]),
            ...mapGetters([
                'getSettings', 'getFirstCurrentPage'
            ]),
        },
    }
</script>

<style scoped>

</style>
